<div class="container-fluid">
  <div *ngIf="!initialLoadComplete"><wl-busy [show]="true"></wl-busy> {{ 'common.loading' | translate | titlecase }}</div>
  <div class="form-horizontal" *ngIf="initialLoadComplete">
    <ul class="list-unstyled list-inline">
      <li>
        <h3>{{ 'events.registration.wizard.items.title' | translate | titlecase }}</h3>
      </li>
      <li [hidden]="!_hasItemsWithMemberPricing">
        <label *ngIf="registration.Registration"
          ><input
            type="checkbox"
            [(ngModel)]="registration.Registration.ForceMemberPricing"
            (ngModelChange)="handleForceMemberPricingChange()"
          />
          {{ 'events.registration.wizard.items.force-member-pricing-label' | translate | titlecase }}</label
        >
      </li>
    </ul>

    <div class="form-group hidden-xs">
      <div class="col-sm-4">
        <strong>{{ 'events.registration.wizard.items.event-item-name-label' | translate | titlecase }}</strong>
      </div>
      <div class="col-sm-2 text-right hidden-xs">
        <strong>{{ 'events.registration.wizard.items.price-label' | translate | titlecase }}</strong>
      </div>
      <div class="col-sm-3 text-right hidden-xs">
        <strong>{{ 'events.registration.wizard.items.quantity-label' | translate | titlecase }}</strong>
      </div>
      <div class="col-sm-2 text-right hidden-xs">
        <strong>{{ 'events.registration.wizard.items.total-label' | translate | titlecase }}</strong>
      </div>
    </div>
    <div class="highlight-box-xs" data-cy="divRegistrationWizardItemContainer" *ngFor="let item of registration.Items">
      <div class="form-group">
        <div class="col-sm-4" data-cy="divRegistrationWizardItemName">
          {{ item.Descr }}

          <div class="text-indent" *ngIf="item.AttendeesForItem > 1">
            <em>{{ item.AttendeesForItem }} {{ 'events.registration.wizard.items.attendees-included' | translate }}</em>
          </div>
          <div class="text-indent" *ngIf="item.AttendeesForItem <= 0">
            <em>{{ 'events.registration.wizard.items.ticket-has-no-attendees-label' | translate }}</em>
          </div>
          <div class="text-indent" *ngIf="item.Quantity > 0 && hasCustomRegFields(item.EventItemId)">
            {{ 'events.registration.wizard.items.see-below-for-additional-information' | translate }}
          </div>
        </div>
        <div class="col-sm-2 text-right text-left-xs">
          <div class="visible-xs-block">
            <strong>{{ 'events.registration.wizard.items.price-label' | translate | titlecase }}</strong>
          </div>

          <div data-cy="divRegistrationWizardItemPrice">
            <span
              *ngIf="!item.HasMemberPricing"
              [title]="
                (item.MembersOnly
                  ? 'events.registration.wizard.items.member-price-label'
                  : 'events.registration.wizard.items.non-member-price-label'
                )
                  | translate
                  | titlecase
              "
              >{{ item.NonMemberPrice | currency }}</span
            >
            <span *ngIf="item.HasMemberPricing">
              <span [title]="'events.registration.wizard.items.member-price-label' | translate | titlecase">{{
                item.MemberPrice | currency
              }}</span>
              {{ 'events.registration.wizard.items.member-price-label' | translate | titlecase }}<br /><span
                [title]="'events.registration.wizard.items.non-member-price-label' | translate | titlecase"
                >{{ item.NonMemberPrice | currency }}
                {{ 'events.registration.wizard.items.non-member-price-label' | translate | ucfirst }}</span
              >
            </span>
          </div>
        </div>
        <div class="col-sm-3 text-right text-left-xs" data-cy="divRegistrationWizardItemQuantity">
          <div class="visible-xs-block">
            <strong>{{ 'events.registration.wizard.items.quantity-label' | translate | titlecase }}</strong>
          </div>
          <div>
            <p-progressSpinner data-cy="spinnerRegistrationWizardItemQuantity" size="3" [(ngModel)]="item.Quantity" (ngModelChange)="quantityChanged()"></p-progressSpinner>
          </div>
          <div>
            <strong>
              <span [hidden]="item.MaxItemsAvail < 1 || item.Remaining < 1"
                >({{ item.Remaining }}&nbsp;{{ 'events.registration.wizard.items.items-available-text' | translate | titlecase }})</span
              >
              <span data-cy="spanRegistrationWizardItemSoldOut" [hidden]="item.MaxItemsAvail < 1 || item.Remaining > 0"
                >({{ 'events.registration.wizard.attendees.item-sold-out-label' | translate | titlecase }})</span
              >
            </strong>
          </div>
        </div>
        <div class="col-sm-2 text-right text-left-xs" *ngIf="item.Quantity > 0">
          <div class="visible-xs-block">
            <strong>{{ 'events.registration.wizard.items.total-label' | translate | titlecase }}</strong>
          </div>
          <div>{{ item.DisplayPrice | currency }}</div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="showCustomFields()">
      <div class="col-sm-12">
        <h4>{{ 'events.registration.wizard.items.custom-reg-field-title' | translate | titlecase }}</h4>
      </div>
    </div>

    <wl-registration-custom-reg-fields
      [customFields]="allPossibleCustomFields"
      [responses]="registration.Registration.EventCustomRegFieldResponses"
      [visibilityFilter]="[_eventFieldVisibleRequiredEnum.RegistrationOnly, _eventFieldVisibleRequiredEnum.BothRegistrationAndAttendee]"
      [eventItemIds]="_selectedEventItemIds"
      (responseChange)="onResponseChange($event)"
    ></wl-registration-custom-reg-fields>
  </div>
</div>
